import '../camp_version'
import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/Vuetify'
import i18n from '@/plugins/VueI18n'
import { VueTelInput } from 'vue-tel-input'
import filter from '@/plugins/Filter'

import '@/plugins/GlobalComponents'
import '@/assets/css/fonts.css'
import '@/plugins/Chartist'
import '@/plugins/Base'

Vue.config.productionTip = false
Vue.component('VueTelInput', VueTelInput)
Vue.use(VueTelInput)
new Vue({
  filter,
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
